import { EventSearchRow } from '@mark43/cad-api';
import { HStack, Icon, VStack, Button } from '@cad-arc';
import { globalAttributes } from '../common/global-attributes';
import { FR_EVENT_DETAILS_TABS } from '../fr-event-details-page/constants';
import { EVENT_SEARCH_WINDOW_PATH } from '../router/constants';
import { useOpenEvent } from '../common/hooks/use-open-event';
import { PriorityCaution } from '../common/components/priority-caution';

export function EventSearchResultsEventNumberCell({
    eventSearchRow,
}: Readonly<{
    eventSearchRow: EventSearchRow;
}>) {
    const isPriority1 =
        eventSearchRow.priorityGlobalAttrId === globalAttributes.cfsPriorityGlobal.CFS_PRIORITY_1;

    const locationState = {
        previousLocationPathname: EVENT_SEARCH_WINDOW_PATH,
    };

    const handleOpenEvent = useOpenEvent();

    return (
        <VStack align="left">
            <HStack>
                {eventSearchRow.priority && (
                    <PriorityCaution
                        label={eventSearchRow.priority}
                        priorityAttrId={eventSearchRow.priorityAttrId}
                        agencyTypeGlobalAttrId={eventSearchRow.agencyTypeGlobalAttrId}
                        isPriority1={isPriority1}
                    />
                )}
                <Button
                    variant="ghost"
                    trailingVisual="OpenNewWindow"
                    onClick={() =>
                        handleOpenEvent({
                            eventId: eventSearchRow.eventId,
                            frEventDetailsTabName: FR_EVENT_DETAILS_TABS.NARRATIVE,
                            locationState,
                        })
                    }
                >
                    {eventSearchRow.eventNumber}
                </Button>
            </HStack>
            {eventSearchRow.parentEventId && (
                <HStack>
                    <Icon icon="Merge" color="icon.default" />
                    <Button
                        variant="ghost"
                        trailingVisual="OpenNewWindow"
                        onClick={() =>
                            handleOpenEvent({
                                eventId: eventSearchRow.parentEventId,
                                frEventDetailsTabName: FR_EVENT_DETAILS_TABS.NARRATIVE,
                                locationState,
                            })
                        }
                    >
                        Primary Event
                    </Button>
                </HStack>
            )}
        </VStack>
    );
}
